import { adjustToMonth, computeCardDueDate, isDateInRange, shiftMonth } from './dateUtils'

export type CardCycle = { close: number; due: number }

export type RecurringProjectionInput = {
  date: string
  recurring_until?: string | null
  card_id?: string | null
  due_date?: string | null
}

function yearMonth(isoDate: string): { month: number; year: number } {
  const [year, month] = isoDate.split('-').map(Number)
  return { month, year }
}

function monthSerial(month: number, year: number): number {
  return year * 12 + month
}

export function projectRecurringRowInRange<T extends RecurringProjectionInput>(
  row: T,
  from: string,
  to: string,
  cycle?: CardCycle,
): Array<T & { date: string; due_date: string | null; realized: false }> {
  const fromMonth = yearMonth(from)
  const toMonth = yearMonth(to)
  const start = cycle ? shiftMonth(fromMonth.month, fromMonth.year, -2) : fromMonth
  const end = shiftMonth(toMonth.month, toMonth.year, -1)

  const projected: Array<T & { date: string; due_date: string | null; realized: false }> = []

  for (
    let current = start;
    monthSerial(current.month, current.year) <= monthSerial(end.month, end.year);
    current = shiftMonth(current.month, current.year, 1)
  ) {
    const projectedDate = adjustToMonth(row.date, current.month, current.year)
    if (projectedDate <= row.date) continue
    if (row.recurring_until && projectedDate > row.recurring_until) continue

    const effectiveDate = cycle
      ? computeCardDueDate(projectedDate, cycle.close, cycle.due)
      : projectedDate
    if (!isDateInRange(effectiveDate, from, to)) continue

    projected.push({
      ...row,
      date: projectedDate,
      due_date: cycle ? effectiveDate : row.due_date ?? null,
      realized: false,
    })
  }

  return projected
}
